// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Layout */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.App-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.App-header h1 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.App-header nav {
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
}

.App-header nav a {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.App-header nav a:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* Main Content */
.App-main {
  flex: 1 1;
  padding: 2rem 0;
}

/* Footer */
.App-footer {
  background-color: #2d3748;
  color: #a0aec0;
  padding: 1.5rem 0;
  text-align: center;
  margin-top: auto;
}

.App-footer p {
  margin: 0;
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .App-header h1 {
    font-size: 1.5rem;
  }

  .App-header nav {
    flex-direction: column;
    gap: 0.5rem;
  }

  .App-header nav a {
    text-align: center;
  }

  .App-main {
    padding: 1rem 0;
  }
}

/* Loading und Error States */
.loading {
  text-align: center;
  padding: 3rem;
  font-size: 1.2rem;
  color: #667eea;
}

.error-message {
  background-color: #fed7d7;
  color: #c53030;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  border-left: 4px solid #c53030;
}

.success-message {
  background-color: #c6f6d5;
  color: #22543d;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  border-left: 4px solid #22543d;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":["/* App Layout */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.App-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 1.5rem 0;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.App-header h1 {\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.App-header nav {\n  display: flex;\n  gap: 1.5rem;\n  margin-top: 1rem;\n}\n\n.App-header nav a {\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.App-header nav a:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n/* Main Content */\n.App-main {\n  flex: 1;\n  padding: 2rem 0;\n}\n\n/* Footer */\n.App-footer {\n  background-color: #2d3748;\n  color: #a0aec0;\n  padding: 1.5rem 0;\n  text-align: center;\n  margin-top: auto;\n}\n\n.App-footer p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .App-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .App-header nav {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .App-header nav a {\n    text-align: center;\n  }\n\n  .App-main {\n    padding: 1rem 0;\n  }\n}\n\n/* Loading und Error States */\n.loading {\n  text-align: center;\n  padding: 3rem;\n  font-size: 1.2rem;\n  color: #667eea;\n}\n\n.error-message {\n  background-color: #fed7d7;\n  color: #c53030;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  border-left: 4px solid #c53030;\n}\n\n.success-message {\n  background-color: #c6f6d5;\n  color: #22543d;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  border-left: 4px solid #22543d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
